export default __webpack_public_path__ + "static/media/element-3.9dbe0bb0.svg";